module.exports = __webpack_public_path__ + "img/user.bd656272.svg";